import {http} from '@/http/index.js';

async function getPostAudienceList() {
  return http.get('/post-audience').then((response) => response.data);
}

export {getPostAudienceList};
